export default "__VITE_ASSET__BBMFy8_p__"